import React from 'react';
import { Helmet } from 'react-helmet-async';

// Open Graph + Twitter com a imagem padrão do site. Mesmo conjunto que a
// SobrePage e o skeleton do prerender escrevem à mão.
const OgMeta: React.FC<{ title: string; description: string; path: string }> = ({ title, description, path }) => (
  <Helmet>
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`https://luisbrunello.com.br${path}`} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Dr. Luis Brunello" />
    <meta property="og:locale" content="pt_BR" />
    <meta property="og:image" content="https://luisbrunello.com.br/og-image.jpg" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content="https://luisbrunello.com.br/og-image.jpg" />
  </Helmet>
);

export default OgMeta;
